import { Eye, Pencil, MoreHorizontal } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Row action buttons: view (eye), optional edit (pencil), optional extra items.
 */
export function RowActions({ onView, onEdit, moreItems = [], testId }) {
  return (
    <div className="flex items-center justify-end gap-0.5" data-testid={testId}>
      {onView && (
        <button
          type="button"
          onClick={onView}
          data-testid={testId ? `${testId}-view` : "row-action-view"}
          title="View"
          className="flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-[#F5E6EC] hover:text-[#910029]"
        >
          <Eye className="h-3.5 w-3.5" />
        </button>
      )}
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          data-testid={testId ? `${testId}-edit` : "row-action-edit"}
          title="Edit"
          className="flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-[#F5E6EC] hover:text-[#910029]"
        >
          <Pencil className="h-3.5 w-3.5" />
        </button>
      )}
      {moreItems.map((item, idx) => {
        const ItemIcon = item.icon;
        return (
          <button
            key={idx}
            type="button"
            onClick={item.onClick}
            title={item.label}
            aria-label={item.label}
            data-testid={testId ? `${testId}-${item.label.toLowerCase().replace(/\s+/g, "-")}` : undefined}
            disabled={item.disabled}
            className={cn(
              "flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground transition-colors",
              item.disabled && "cursor-not-allowed opacity-50",
              item.danger
                ? "hover:bg-rose-50 hover:text-rose-600"
                : "hover:bg-[#F5E6EC] hover:text-[#910029]"
            )}
          >
            {ItemIcon && <ItemIcon className="h-3.5 w-3.5" />}
          </button>
        );
      })}
    </div>
  );
}
